import React, { useState, useEffect, useRef } from 'react'
import { Form, Col, Button } from 'react-bootstrap'
import { useFormContext } from 'react-hook-form'
import { Typeahead } from 'react-bootstrap-typeahead'
import CustomInput from './CustomInput'
import PuntosDeVenta from './PuntosDeVenta'

function CustomSucursal({
  label,
  name,
  actividades,
  actividadesiibb,
  remove,
  index,
  field,
  visualizar,
  modificar,
  location
}) {
  const { errors, register, getValues, watch, setValue } = useFormContext()

  const firstRender = useRef(true)
  const [principal, setPrincipal] = useState([])
  const [selected, setSelected] = useState([])

  const watchActividadPrincipal = watch(`${name}.${index}.actividad_principal`)
  const watchTipoActividad = watch(`${name}.${index}.tipo_codigo_actividad`)

  useEffect(() => {
    if (Number(watchActividadPrincipal) > 0 && firstRender.current) {
      let actividad = (
        watchTipoActividad === 'catID' ? actividades : actividadesiibb
      ).filter((act) => act.value === Number(watchActividadPrincipal))

      if (watchTipoActividad === 'catID') {
        setSelected(actividad)
      } else {
        setPrincipal(actividad)
      }
      firstRender.current = false
    }
  }, [
    watchActividadPrincipal,
    watchTipoActividad,
    actividades,
    actividadesiibb
  ])

  useEffect(() => {
    setValue(
      `${name}.${index}.actividad_principal`,
      principal?.[0]?.value ?? 0,
      { shouldValidate: true }
    )
  }, [principal, name, index, setValue])

  useEffect(() => {
    if (selected.length > 0) {
      setValue(`${name}.${index}.tipo_codigo_actividad`, 'aibID')
    }
  }, [setValue, name, index, selected])

  return (
    <>
      <Form.Row>
        <input
          style={{ display: 'none' }}
          name={`${name}.${index}.legajo`}
          defaultValue={field.legajo}
          ref={register({ required: false })}
        />

        <input
          style={{ display: 'none' }}
          name={`${name}.${index}.tipo_codigo_actividad`}
          defaultValue={field.tipo_codigo_actividad}
          ref={register({ required: false })}
        />

        <CustomInput
          md={6}
          label={`${label} ${index + 1}`}
          placeholder="Ingrese nombre de la calle"
          type="text"
          name={`${name}.${index}.domicilio_calle`}
          defaultValue={field.domicilio_calle}
          errorPath={errors?.[name]?.[index]?.domicilio_calle}
          validation={{
            required: {
              value: true,
              message: 'Es necesario ingresar la calle.'
            }
          }}
          disabled={visualizar || (field.legajo && modificar)}
        />

        <CustomInput
          md={3}
          label={`Número ${index + 1}`}
          placeholder="Numeración"
          type="number"
          name={`${name}.${index}.domicilio_numero`}
          defaultValue={field.domicilio_numero}
          errorPath={errors?.[name]?.[index]?.domicilio_numero}
          validation={{
            required: {
              value: true,
              message: 'Es necesario ingresar un número.'
            },
            valueAsNumber: true,
            min: {
              value: 0,
              message: 'El número debe ser mayor a 0.'
            }
          }}
          disabled={visualizar || (field.legajo && modificar)}
        />

        <CustomInput
          md={3}
          label={`Piso ${index + 1}`}
          placeholder="Piso"
          type="number"
          name={`${name}.${index}.domicilio_piso`}
          defaultValue={field.domicilio_piso}
          validation={{
            required: false
          }}
          disabled={visualizar || (field.legajo && modificar)}
        />
      </Form.Row>

      <Form.Row>
        <CustomInput
          label={`Localidad ${index + 1}`}
          placeholder="Ingrese la localidad"
          md={6}
          type="text"
          name={`${name}.${index}.localidad`}
          defaultValue={field.localidad}
          errorPath={errors?.[name]?.[index]?.localidad}
          validation={{
            required: {
              value: true,
              message: 'Es necesario ingresar la localidad.'
            }
          }}
          disabled={visualizar || (field.legajo && modificar)}
        />

        <CustomInput
          md={3}
          label={`Partida inmobiliaria ${index + 1}`}
          type="number"
          name={`${name}.${index}.partida_inmobiliaria`}
          placeholder="Ingrese una partida inmobiliaria"
          defaultValue={field.partida_inmobiliaria}
          errorPath={errors?.[name]?.[index]?.partida_inmobiliaria}
          validation={{
            required: {
              value: true,
              message:
                'Es necesario ingresar un número de partida inmobiliaria.'
            },
            valueAsNumber: true,
            min: {
              value: 0,
              message: 'El número debe ser mayor a 0.'
            }
          }}
          disabled={visualizar || (field.legajo && modificar)}
        />

        <CustomInput
          label={`Código postal ${index + 1}`}
          placeholder="Código postal"
          md={3}
          type="text"
          name={`${name}.${index}.codigo_postal`}
          defaultValue={field.codigo_postal}
          errorPath={errors?.[name]?.[index]?.codigo_postal}
          validation={{
            required: {
              value: true,
              message: 'Es necesario ingresar el código postal.'
            },
            min: {
              value: 1,
              message: 'Debe ser un número mayor a cero.'
            }
          }}
          disabled={visualizar || (field.legajo && modificar)}
        />
      </Form.Row>

      {name !== 'externas' && (
        <input
          name={`${name}.${index}.actividad_principal`}
          defaultValue=""
          style={{ display: 'none' }}
          ref={register({
            required: {
              value: name !== 'externas',
              message: 'Es necesario seleccionar una actividad.'
            },
            validate: {
              selectedSomething: (value) =>
                Number(value) > 0 || 'Es necesario seleccionar una actividad.'
            }
          })}
        />
      )}

      {(watchTipoActividad === 'catID' || selected.length > 0) && (
        <Form.Row>
          <Col md={8}>
            <Form.Group>
              <Form.Label>Actividad anterior</Form.Label>

              <Form.Control
                type="text"
                disabled
                value={
                  selected.length > 0
                    ? `${selected[0].id} - ${selected[0].descripcion}`
                    : ''
                }
              />
            </Form.Group>
          </Col>
        </Form.Row>
      )}

      <Form.Row>
        {name !== 'externas' && (
          <Col md={8}>
            <Form.Group>
              <Form.Label>Actividad principal</Form.Label>

              <Typeahead
                id={`${name}.${index}.actividad_principal`}
                placeholder="Seleccione una actividad principal"
                paginationText="Mostrar más opciones..."
                labelKey={(option) => `${option.id} - ${option.descripcion}`}
                emptyLabel="No existen actividades para esta búsqueda."
                options={actividadesiibb}
                highlightOnlyResult={true}
                ignoreDiacritics={true}
                onChange={(v) => setPrincipal(v)}
                selected={principal}
                disabled={visualizar}
                isValid={
                  !errors?.[name]?.[index]?.actividad_principal &&
                  getValues(`${name}.${index}.actividad_principal`) > 0
                }
                isInvalid={!!errors?.[name]?.[index]?.actividad_principal}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.[name]?.[index]?.actividad_principal?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        )}
        <CustomInput
          md={name === 'externas' ? 6 : 4}
          label={`Fecha de inicio de actividad en Berisso ${index + 1}`}
          as="input"
          type="date"
          min="1900-01-01"
          max="3000-12-31"
          name={`${name}.${index}.fecha_inicio`}
          defaultValue={field.fecha_inicio}
          errorPath={errors?.[name]?.[index]?.fecha_inicio}
          validation={{
            required: {
              value: true,
              message: 'Es necesario ingresar una fecha de inicio.'
            }
          }}
          disabled={visualizar}
        />
      </Form.Row>

      <PuntosDeVenta
        identificador={`${name}.${index}.puntos_de_venta`}
        name={name}
        index={index}
        disabled={visualizar}
      />

      <Form.Row>
        {index > 0 && (
          <Button
            className="mx-auto d-block mt-4"
            variant="outline-secondary"
            onClick={() => remove(index)}
            disabled={visualizar}
          >
            Eliminar sucursal {name === 'externas' && 'externa'} {index + 1}
          </Button>
        )}
      </Form.Row>
    </>
  )
}

export default CustomSucursal
